import type React from "react";
import intl from 'react-intl-universal'

import { formatDeliveryTime } from 'utils/delivery-time'
import * as S from './styled'

interface DeliveryTimeChangeProps {
  deliveryTime: string;
}

const DeliveryTimeChange: React.FC<DeliveryTimeChangeProps> = ({ deliveryTime }) => (
  <div>
    <S.Container>
      <S.Column isFirstChild>
        <S.Label>{intl.get("commons.deliveryTime")}:</S.Label>
        <S.Value>{formatDeliveryTime(deliveryTime)}</S.Value>
      </S.Column>
    </S.Container>
  </div>
);

export default DeliveryTimeChange;
